import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, ViewChildren, QueryList, HostListener, NgZone, Output, EventEmitter } from '@angular/core';
import { QuestElement, ModeQuestion, MatchingQuestionOption, Option } from '../../../models';

declare var $: any;

@Component({
  selector: 'Matching-Question',
  templateUrl: './MatchingQuestion.component.html',
  styleUrls: ['./MatchingQuestion.component.css', '../../questionnaire.component.css']
})

export class MatchingQuestionComponent implements AfterViewInit, OnInit {

  constructor(private zone: NgZone, private element: ElementRef) {
  }


  startPoint: string;
  toucheX: string;
  toucheY: string;
  color: string;
  idColor: number = 0;
  inModal: boolean;
  linkList: Array<MatchingQuestionOption> = new Array<MatchingQuestionOption>();
  dragEl: any;
  noteQuestion: boolean;
  @ViewChild('canvasDrag', { static: false }) canvasDrag: ElementRef;
  @ViewChild('canvas', { static: false }) canvas: ElementRef;
  @ViewChild('canvasWrapper', { static: false }) canvasWrapper: ElementRef;

  @ViewChild('dragUL', { static: false }) dragUL: ElementRef;
  @ViewChildren('dragElement') dragElement: QueryList<ElementRef>;

  @ViewChild('dropUL', { static: false }) dropUL: ElementRef;
  @ViewChildren('dropElement') dropElement: QueryList<ElementRef>;

  @ViewChild('dragQuestion', { static: false }) dragQuestion: ElementRef;


  // #region Input
  pageId: number;
  @Input() set PageId(value: number) {
    this.pageId = value;
  }

  ModeQuestion = ModeQuestion;
  mode: ModeQuestion;
  displayMode: boolean = false;
  firstLoad: boolean = true;
  @Input() set Mode(value: ModeQuestion) {
    this.mode = value;
    this.displayMode = this.mode == ModeQuestion.cDiplay || this.mode == ModeQuestion.rDiplay;
    if (!this.firstLoad) {
      this.calcResize(0);
    } else {
      this.firstLoad = false;
    }

  }

  @Input() set QuestElement(value: QuestElement) {
    if (value != null) {
      this.questElement = value;
      this.optionGauche = value.options.filter(x => { return x.ordre >= 0 });
      this.optionDroit = value.options.filter(x => { return x.ordre < 0 }).sort(this.compareOder);
    }
  }

  @Input() set DeletedElement(value: Array<string>) {
    if (value != null) {
      this.deletedElement = value;
    }
  }

  @Input() set NoteQuestion(value: boolean) {
    if (value != null) {
      this.noteQuestion = value;
    } else {
      this.noteQuestion = true;
    }
  }

  @Output() GetMaxNote = new EventEmitter<boolean>();
  // #endregion
  deletedElement: Array<string>;
  questElement: QuestElement;
  optionGauche: Array<Option> = new Array<Option>();
  optionDroit: Array<Option> = new Array<Option>();

  // get screen size on window resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.calcResize(0);
  }

  ngOnInit() {
    // Generation de la liste des liens
    if (this.mode == ModeQuestion.create || this.mode == ModeQuestion.cDiplay) {
      let num = 0;
      this.optionGauche.forEach((option: Option) => {
        num++;
        if (option.ctrlValue != '' && option.ctrlValue != undefined) {
          const mqo: MatchingQuestionOption = { dragId: option.ident, dropId: option.ctrlValue, color: this.getRandomColor(option.ctrlType ? option.ctrlType : num.toString()) };
          this.linkList.push(mqo);
        }
      });
    }
    else if (this.mode == ModeQuestion.rDiplay) {
      this.optionGauche.forEach((option: Option) => {
        if (option.answer != '' && option.answer != undefined) {

          let color: string = option.answer == option.ctrlValue ? 'green' : 'red';
          const mqo: MatchingQuestionOption = { dragId: option.ident, dropId: option.answer, color: color };
          this.linkList.push(mqo);
        }
      });
    }

    this.idColor = this.optionGauche.length;
  }


  ngAfterViewInit() {
    this.initMatching();
  }


  public initMatching() {
    this.zone.runOutsideAngular(() => {
      this.addEventsParent(this.dragQuestion);
      this.dragElement.forEach((dragEl: ElementRef) => this.addEventsDrag(dragEl));
      this.dropElement.forEach((dropEl: ElementRef) => this.addEventsDrop(dropEl));
    });
    this.calcResize();
  }

  private getRandomColor(id: string): string {
    const colorArray: Array<string> = ["#54478c", "#2c699a", "#048ba8", "#0db39e", "#16db93", "#83e377", "#b9e769", "#efea5a", "#f1c453", "#f29e4c"]
    return colorArray[parseInt(id) % 10];
  }



  // #region Add event
  private addEventsDrag(el: ElementRef) {
    el.nativeElement.addEventListener('dragstart', this.onDragStart.bind(this));
    el.nativeElement.addEventListener('dragend', this.onDragEnd.bind(this));
    el.nativeElement.addEventListener('touchstart', this.onTouchStart.bind(this));
    el.nativeElement.addEventListener('touchmove', this.onTouchMove.bind(this));
    el.nativeElement.addEventListener('touchend', this.onTouchEnd.bind(this));

  }

  private addEventsDrop(el: ElementRef) {
    el.nativeElement.addEventListener('dragover', this.onDragOver.bind(this));
    el.nativeElement.addEventListener('drop', this.onDrop.bind(this));
    el.nativeElement.addEventListener('touchend', this.onTouchEndClick.bind(this));

  }

  private addEventsParent(el: ElementRef) {
    el.nativeElement.addEventListener('dragover', this.onDragOverParent.bind(this));
    //el.nativeElement.addEventListener('dragleave', this.onDragLeaveParent.bind(this));
  }
  // #endregion

  // #region Drag and Drop
  private onDragStart(event: any) {
    if (event && !this.displayMode) {
      this.calcResize(0);
      this.startPoint = event.target.id;

      this.dragEl = this.dragElement.find((el: ElementRef) => { return el.nativeElement.id == this.startPoint });
      this.p1T = this.dragEl.nativeElement.parentElement.parentElement.offsetTop;
      this.p1H = this.dragEl.nativeElement.clientHeight;
      this.canvasOffset = $(this.canvasWrapper.nativeElement).offset();

      console.clear();
      this.color = this.getRandomColor(event.target.getAttribute('idColor'));
    } else {
      event.preventDefault();
    }
  }



  private onDragOver(event: DragEvent) {
    if (this.startPoint) {
      event.preventDefault();
    }
  }

  private onDragEnd(event: DragEvent) {
    this.clearPathDrag();
    this.resetStat();
    event.preventDefault();
  }

  private onDrop(event: any) {
    if (this.startPoint) {
      const dragId: string = this.startPoint;
      const dropId: string = event.target.id;
      this.drop(dragId, dropId);
      this.resetStat();
    }
  }



  private onDragOverParent(event: any) {
    event.preventDefault();
    //if (this.startPoint) {
    const top = event.pageY - this.canvasOffset.top, left = event.pageX - this.canvasOffset.left;
    this.drawLinkDrag({ top, left });
    //}
  }

  private onDragLeaveParent(event: any) {
    if (event.explicitOriginalTarget && event.explicitOriginalTarget.classList.contains('dropElement')) {
      event.preventDefault();
    }
    else {
      let el = event.fromElement;
      let isOut: boolean = true;
      while (el) {
        if (el.classList.contains('linkingQuestion')) {
          isOut = false;
          break;
        }
        el = el.parentElement;
      }

      if (isOut) {
        this.clearPathDrag();
        this.resetStat();
        return false;
      }
    }
  }

  toucheStart: any;
  toucheMove: boolean;
  private onTouchStart(event: any) {
    if (event && !this.displayMode) {
      this.toucheStart = event;
      this.calcResize(0);
      this.dragEl = event.currentTarget;
      this.startPoint = this.dragEl.id;
      this.p1T = this.dragEl.parentElement.parentElement.offsetTop;
      this.p1H = this.dragEl.clientHeight;
      this.canvasOffset = $(this.canvasWrapper.nativeElement).offset();

      this.color = this.getRandomColor(event.currentTarget.getAttribute('idColor'));
      setTimeout(() => { this.dragEl.firstChild.style.color = this.color, 10 });  

      this.dropElement.forEach((drop: any) => {
        drop.nativeElement.classList.add('blinkingDot');
      });

    } else {
      event.preventDefault();
    }
  }


  private onTouchMove(event: any) {
    event.preventDefault();

    if (!this.toucheMove && Math.sqrt(Math.pow(this.toucheStart.touches[0].clientX - event.touches[0].clientX, 2) + Math.pow(this.toucheStart.touches[0].clientY - event.touches[0].clientY, 2)) > 20) {
      this.toucheMove = true;

      let offset: any = $(this.canvasDrag.nativeElement).offset();
      this.toucheY = (event.touches[0].pageY - offset.top).toString();
      this.toucheX = event.touches[0].pageX;

      let top = event.touches[0].pageY - this.canvasOffset.top,
        left = event.touches[0].pageX - this.canvasOffset.left;
      this.drawLinkDrag({ top, left });
    }    
  }

  private onTouchEnd(event: any) {
    if (!this.toucheMove) { return };
    this.toucheMove = false;
    let offset: any = $(this.canvasDrag.nativeElement).offset();
    this.dropElement.forEach((target: ElementRef) => {

      let box2: any = $(target.nativeElement).offset(),

        x = Number(box2.left),
        y = Number(box2.top - offset.top),
        h = target.nativeElement.offsetHeight,
        w = target.nativeElement.offsetWidth,
        b = y + h,
        r = x + w;
      if (Number(this.toucheX) > x && this.toucheX < r && Number(this.toucheY) > y && this.toucheY < b) {
        this.drop(this.startPoint, target.nativeElement.id);
      } else {
        return false;
      }
    });
    this.clearPathDrag();
    this.dropElement.forEach((drop: any) => {
      drop.nativeElement.classList.remove('blinkingDot');
    });
    event.preventDefault();
  }


  private onTouchEndClick(event: any) {
    if (this.toucheMove || !this.startPoint) { return };

    this.drop(this.startPoint, event.changedTouches[0].target.id);
    this.startPoint = '';
    this.dropElement.forEach((drop: any) => {
      drop.nativeElement.classList.remove('blinkingDot');
    });
    event.preventDefault();
  }

  // #endregion

  // #region Link management
  p1T: any;
  p1H: any;
  canvasOffset: any;

  private drawLinkDrag(mousePos: any) {
    const ctxDrag: CanvasRenderingContext2D = this.canvasDrag.nativeElement.getContext('2d');

    ctxDrag.beginPath();
    ctxDrag.strokeStyle = this.color;
    ctxDrag.lineWidth = 3;

    ctxDrag.moveTo(0, this.p1T + (this.p1H / 2));

    ctxDrag.bezierCurveTo(
      mousePos.left / 2, this.p1T,
      mousePos.left / 2, mousePos.top,
      mousePos.left, mousePos.top);

    ctxDrag.clearRect(0, 0, this.canvasDrag.nativeElement.width, this.canvasDrag.nativeElement.height);
    ctxDrag.stroke();
  }

  private drawLinks() {
    this.cleanCircle();
    const canvas = this.canvas.nativeElement;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);


    // Generation de la liste des liens si elle est vide 
    if (this.linkList.length) {
      this.linkList.forEach((link: MatchingQuestionOption) => { this.drawLink(link.dragId, link.dropId, link.color); });
    }
  }

  private drawLink(dragId: string, dropId: string, pColor: string) {
    let dragEl: any = this.dragElement.find((el: ElementRef) => { return el.nativeElement.id == dragId });
    let dropEl: any = this.dropElement.find((el: ElementRef) => { return el.nativeElement.id == dropId });

    const canvas = this.canvas.nativeElement;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');

    const p1T = dragEl.nativeElement.parentElement.parentElement.offsetTop + dragEl.nativeElement.offsetTop;
    const p2T = dropEl.nativeElement.parentElement.parentElement.offsetTop + dropEl.nativeElement.offsetTop;

    const canvasW = canvas.width;
    ctx.beginPath();
    ctx.strokeStyle = pColor ? pColor : this.color;
    ctx.lineWidth = 3;
    ctx.moveTo(0, p1T);
    ctx.bezierCurveTo(canvasW / 2, p1T,
      canvasW / 2, p2T,
      canvasW - 10, p2T);

    ctx.stroke();

    let iDrag: any = dragEl.nativeElement.querySelector('.fa-circle');
    iDrag.style.fontWeight = '900';
    iDrag.style.color = pColor ? pColor : this.color;
    let iDrop: any = dropEl.nativeElement.querySelector('.fa-circle');
    iDrop.style.fontWeight = '900';
    iDrop.style.color = pColor ? pColor : this.color;
    iDrop.classList.add('linked');


  }

  private clearPathDrag() {
    const canvas = this.canvasDrag.nativeElement;
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  public clearPath(event: any, directId: boolean = false) {
    if (!this.displayMode) {
      const ident = directId ? event : event.currentTarget.id;
      //delete du lien dans la liste
      this.linkList = this.linkList.filter(obj => {
        return (obj.dropId != ident) == (obj.dragId != ident)
      });


      //delete des liens dans les objs 
      let linkStartPt: any = this.questElement.options.find(opt => { return opt.ident == ident });

      if (linkStartPt.ctrlValue != '') {
        let linkEndPt: any;

        if (this.mode == ModeQuestion.create) {
          linkEndPt = this.questElement.options.find(opt => { return opt.ident == linkStartPt.ctrlValue });
          linkStartPt.ctrlValue = '';
          linkEndPt.ctrlValue = '';
        } else if (this.mode == ModeQuestion.reply) {
          linkEndPt = this.questElement.options.find(opt => { return opt.ident == linkStartPt.answer });
          linkStartPt.answer = '';
          linkEndPt.answer = '';
        }
      }
      this.drawLinks();
    }
  }

  private drop(dragId: string, dropId: string) {

    //Recuperation des liens qui continnent un des deux ident du nouveau lien  
    let deselected: Array<MatchingQuestionOption> = this.linkList.filter(obj => {
      return obj.dragId == dragId || obj.dropId == dropId;
    });

    if (deselected.length) {
      //reset l'affichage des anciens liens
      deselected.forEach((opts: MatchingQuestionOption) => {

        let dragEl: any = this.dragElement.find((el: ElementRef) => { return el.nativeElement.id == opts.dragId });
        let dropEl: any = this.dropElement.find((el: ElementRef) => { return el.nativeElement.id == opts.dropId });
        //remove element de la liste de lien
        this.linkList = this.linkList.filter(obj => { return obj != opts });
        let iDrop: any = dropEl.nativeElement.querySelector('.fa-circle');
        iDrop.style.fontWeight = '400';
        iDrop.style.color = 'black';
        iDrop.classList.remove('linked');
        let iDrag: any = dragEl.nativeElement.querySelector('.fa-circle');
        iDrag.style.fontWeight = '400';
        iDrag.style.color = 'black';
      })
    }

    //set le nouveau lien
    let startOption: any = this.questElement.options.find(x => x.ident == dragId);
    let endOption: any = this.questElement.options.find(x => x.ident == dropId);
    if (this.mode == ModeQuestion.create) {

      //reset des valeurs des anciens liens
      this.questElement.options.filter(x => { return x.ctrlValue == dragId }).forEach((option: Option) => { option.ctrlValue = '' });
      this.questElement.options.filter(x => { return x.ctrlValue == dropId }).forEach((option: Option) => { option.ctrlValue = '' });

      startOption.ctrlValue = dropId;
      endOption.ctrlValue = dragId;
    } else if (this.mode == ModeQuestion.reply) {

      //reset des valeurs des anciens liens
      this.questElement.options.filter(x => { return x.answer == dragId }).forEach((option: Option) => { option.answer = '' });
      this.questElement.options.filter(x => { return x.answer == dropId }).forEach((option: Option) => { option.answer = '' });

      startOption.answer = dropId;
      endOption.answer = dropId;
    }

    //add le lien dans la liste des liens
    this.linkList.push({ dragId: dragId, dropId: dropId, color: this.getRandomColor(startOption.ctrlType) });

    this.drawLinks();
    this.clearPathDrag();
  }

  private resetStat() {
    this.color = this.toucheY = this.toucheX = this.startPoint = '';
  }

  // #endregion

  // #region Create
  public addOption(side: string) {
    let option: Option = new Option();
    option.ident = Date.now().toString();

    switch (side) {
      case "Gauche":
        option.ordre = this.dragElement.toArray().length + 1;
        this.optionGauche.push(option);
        option.ctrlType = this.idColor.toString();
        this.idColor++;
        setTimeout(() => {
          this.dragElement.toArray()[this.dragElement.length - 1].nativeElement.focus();
          this.dragElement.forEach((dragEl: ElementRef) => this.addEventsDrag(dragEl));
        }, 10);
        break;
      case "Droit":
        option.ordre = -(this.dropElement.toArray().length + 1);
        this.optionDroit.push(option);
        setTimeout(() => {
          this.dropElement.toArray()[this.dropElement.length - 1].nativeElement.focus();
          this.dropElement.forEach((dropEl: ElementRef) => this.addEventsDrop(dropEl));
        }, 10);
        break;
    }
    this.questElement.options.push(option);
    this.calcResize(0);
  }

  public deleteOption(option: Option) {

    //delete le lien s'il existe 
    if ((option.ctrlValue != '' && this.mode == ModeQuestion.create) || (option.answer != '' && ModeQuestion.reply)) {
      this.clearPath(option.ident, true);
    }
    this.questElement.options.splice(this.questElement.options.indexOf(option), 1);
    if (option.ident != '0') {
      this.deletedElement.push(option.ident);
    }
    this.optionGauche = this.questElement.options.filter(x => { return x.ordre >= 0 });
    this.optionDroit = this.questElement.options.filter(x => { return x.ordre < 0 }).sort(this.compareOder);
    this.calcResize(0);
  }

  public calcResize(timeout: number = 1000, reDraw: boolean = true) {
    setTimeout(() => {
      let height = this.canvasWrapper.nativeElement.getBoundingClientRect().height;
      let width = this.canvasWrapper.nativeElement.getBoundingClientRect().width;
      this.canvas.nativeElement.setAttribute('height', height);
      this.canvas.nativeElement.setAttribute('width', width);

      this.canvasDrag.nativeElement.setAttribute('height', height);
      this.canvasDrag.nativeElement.setAttribute('width', width);
      if (reDraw) {
        this.drawLinks();
      }
    }, timeout)
  }

  public cleanCircle() {
    const iDragQuestion = this.dragQuestion.nativeElement.querySelectorAll('.fa-circle');
    iDragQuestion.forEach((x: any) => {
      x.classList.remove('linked');
      x.style.fontWeight = '400';
      x.style.color = 'black';
    });
  }


  getMaxNote(): void {
    let pointMax: number = 0;
    this.questElement.options.forEach((opt: Option) => pointMax += opt.point ? +opt.point : 0);
    this.questElement.maxPoint = pointMax;
    this.GetMaxNote.emit(true);
  }


  compareOder(a: any, b: any) {
    const ordreA = a.ordre;
    const ordreB = b.ordre;
    if (ordreA > ordreB) {
      return -1;
    } else if (ordreA < ordreB) {
      return 1;
    }
    return 0;
  }


  // #endregion
}
